import React from 'react';

export default function WaitingClockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99325 1.33301C4.31325 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31325 14.6663 7.99325 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99325 1.33301ZM7.99992 13.333C5.05325 13.333 2.66659 10.9463 2.66659 7.99967C2.66659 5.05301 5.05325 2.66634 7.99992 2.66634C10.9466 2.66634 13.3333 5.05301 13.3333 7.99967C13.3333 10.9463 10.9466 13.333 7.99992 13.333ZM7.85325 4.66634H7.81325C7.54659 4.66634 7.33325 4.87967 7.33325 5.14634V8.29301C7.33325 8.52634 7.45325 8.74634 7.65992 8.86634L10.4266 10.5263C10.6533 10.6597 10.9466 10.593 11.0799 10.3663C11.2199 10.1397 11.1466 9.83967 10.9133 9.70634L8.33325 8.17301V5.14634C8.33325 4.87967 8.11992 4.66634 7.85325 4.66634Z"
        fill="#969696"
      />
    </svg>
  );
}
